const defaultBible = 'ubo';
const defaultBook = 'Gen';
const defaultChapter = 1;

export { 
    defaultBible,
    defaultBook,
    defaultChapter
}